import { CustomButton } from 'components/ui'
import { OptionsItem, SelectInput } from 'components/ui/Forms/SelectInput'
import TextInput from 'components/ui/Forms/TextInput'
import { useFormik } from 'formik'
import DatesInputsCalendar from './DatesInputsCalendar'
import { infoProjectValidation } from 'lib/validation/yupValidation'
import { useUpdateSingleProjectByUserAdmin } from 'lib/react-query/queriesProject'
import { useAuth0 } from '@auth0/auth0-react'
import { useNavigate, useParams } from 'react-router-dom'
import { useState } from 'react'

import { Tooltip } from 'react-tooltip'
import { IconCheck, IconCross, IconPencil } from 'lib/icons/Icon'

const statusS_PROJECT = ['Planificación', 'Oferta', 'Abierto', 'Completado']
const typeCodeOptions = ['Jit', 'Cliente']

const FormEditProyecto = ({ proyecto }) => {
  const { user } = useAuth0()
  const { idProject } = useParams()
  const { mutateAsync } = useUpdateSingleProjectByUserAdmin(user.sub, idProject)

  const [idDisabled, setIdDisabled] = useState(true)
  const [hubDisabled, setHubDisabled] = useState(true)
  const [showIdButtons, setShowIdButtons] = useState(false)
  const [showHubButtons, setShowHubButtons] = useState(false)
  const [showItemWarning, setShowItemWarning] = useState(false)
  const [showHubWarning, setShowHubWarning] = useState(false)

  const navigate = useNavigate()

  const { handleChange, values, errors, handleSubmit, setFieldValue } =
    useFormik({
      initialValues: {
        code: proyecto?.code || '',
        name: proyecto?.name || '',
        description: proyecto?.description || '',
        status: proyecto?.status || '',
        startAt: new Date(proyecto?.startAt) || new Date(),
        finishAt: proyecto?.finishAt ? new Date(proyecto?.finishAt) : '',
        item: proyecto?.item || '',
        hubId: proyecto?.hubId || '',
        typeCode: proyecto?.typeCode || '',
      },
      onSubmit: values => {
        mutateAsync({ body: values }).then(() => {
          setShowItemWarning(false)
          setShowHubWarning(false)
          navigate(-1)
        })
      },
      validationSchema: infoProjectValidation,
    })

  const handleEditId = () => {
    setIdDisabled(false)
    setShowIdButtons(true)
  }

  const handleEditHub = () => {
    setHubDisabled(false)
    setShowHubButtons(true)
  }

  const handleConfirmId = async () => {
    setIdDisabled(true)
    setShowIdButtons(false)
    setShowItemWarning(true)
  }

  const handleCancelId = () => {
    setIdDisabled(true)
    setShowIdButtons(false)
    setFieldValue('item', proyecto?.item || '')
  }

  const handleConfirmHub = async () => {
    setHubDisabled(true)
    setShowHubButtons(false)
    setShowHubWarning(true)
  }

  const handleCancelHub = () => {
    setHubDisabled(true)
    setShowHubButtons(false)
    setFieldValue('hubId', proyecto?.hubId || '')
  }

  const isSaveDisabled = showIdButtons || showHubButtons

  return (
    <form
      onSubmit={handleSubmit}
      noValidate
      className="form-main-info-proyecto-container-edit"
    >
      <div className="calendars-inputs-container">
        <div className="calendar-input-container">
          <TextInput
            label="Código"
            labelClass="label-class"
            name="code"
            value={values.code}
            onChange={handleChange}
          />
          {errors.code && <p className="error-form">{errors.code}</p>}
        </div>
        <div className="calendar-input-container">
          <SelectInput
            label="Tipo Código"
            name="typeCode"
            value={values.typeCode}
            onChange={handleChange}
          >
            {typeCodeOptions.map((option, i) => (
              <OptionsItem key={i} name="typeCode" value={option}>
                {option}
              </OptionsItem>
            ))}
          </SelectInput>
          {errors.typeCode && <p className="error-form">{errors.typeCode}</p>}
        </div>
      </div>

      <div>
        <TextInput
          label="Nombre"
          labelClass="label-class"
          name="name"
          value={values.name}
          onChange={handleChange}
        />
        {errors.name && <p className="error-form">{errors.name}</p>}
      </div>

      <div>
        <TextInput
          label="Descripción"
          labelClass="label-class"
          name="description"
          value={values.description}
          onChange={handleChange}
        />
        {errors.description && (
          <p className="error-form">{errors.description}</p>
        )}
      </div>
      <div>
        <SelectInput
          value={values.status}
          onChange={handleChange}
          name="status"
        >
          {statusS_PROJECT.map((status, i) => (
            <OptionsItem key={i} name="status" value={status}>
              {status}
            </OptionsItem>
          ))}
        </SelectInput>
        {errors.status && <p className="error-form">{errors.status}</p>}
      </div>
      <div className="calendars-inputs-container">
        <div className="calendar-input-container">
          <DatesInputsCalendar
            label="Fecha inicio"
            labelClass="label-class"
            name="startAt"
            date={values.startAt}
            handleChange={day => setFieldValue('startAt', day)}
          />
        </div>
        <div className="calendar-input-container">
          <DatesInputsCalendar
            label="Fecha fin"
            labelClass="label-class"
            name="finishAt"
            date={values.finishAt}
            handleChange={day => setFieldValue('finishAt', day)}
            disabled={values.status !== 'Completado'}
          />
          {errors.finishAt && <p className="error-form">{errors.finishAt}</p>}
        </div>
      </div>

      <div className="input-wrapper">
        <TextInput
          label="Item Id"
          labelClass="label-class"
          name="item"
          value={values.item}
          onChange={handleChange}
          disabled={idDisabled}
          automaticClean={false}
          adornment={
            <div className="adornment-container">
              {showIdButtons ? (
                <>
                  <IconCheck className="pencil" onClick={handleConfirmId} />
                  <IconCross
                    className="pencil"
                    onClick={handleCancelId}
                    style={{ color: 'red' }}
                  />
                </>
              ) : (
                <IconPencil className="pencil" onClick={handleEditId} />
              )}
            </div>
          }
        />
        {showItemWarning && (
          <div className="warning-tipos-button-icon warning-tipos-button--item-id">
            <p className="warning-tipos-icon">!</p>
          </div>
        )}
      </div>

      <div className="input-wrapper">
        <TextInput
          label="Hub Id"
          labelClass="label-class"
          name="hubId"
          value={values.hubId}
          onChange={handleChange}
          disabled={hubDisabled}
          automaticClean={false}
          adornment={
            <div className="adornment-container">
              {showHubButtons ? (
                <>
                  <IconCheck className="pencil" onClick={handleConfirmHub} />
                  <IconCross
                    className="pencil"
                    onClick={handleCancelHub}
                    style={{ color: 'red' }}
                  />
                </>
              ) : (
                <IconPencil className="pencil" onClick={handleEditHub} />
              )}
            </div>
          }
        />
        {showHubWarning && (
          <div className="warning-tipos-button-icon warning-tipos-button--hub-id">
            <p className="warning-tipos-icon">!</p>
          </div>
        )}
      </div>

      {(showItemWarning || showHubWarning) && (
        <Tooltip
          className="Advertencia"
          anchorSelect=".warning-tipos-button-icon"
        >
          Para actualizar el campo, darle a Guardar
        </Tooltip>
      )}

      <div className="button-container">
        <CustomButton type="submit" disabled={isSaveDisabled}>
          <p className="button-text">Guardar</p>
        </CustomButton>
      </div>
    </form>
  )
}

export default FormEditProyecto
